import {
  Breadcrumb,
  DatePicker,
  Input,
  message,
  Radio,
  Select,
  Space,
  Spin,
  Tabs,
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AddGrey,
  AddIcon,
  BackIcon,
  DateIcon,
  DotHour,
  TabDepot1,
  TabDepot2,
  TabDepot3,
} from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsSmall from "../../../component/maps/MapsSmall";
import style from "./DepotConfigAdd.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import _ from "lodash";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { GROLOG_URL } from "../../../constant/apiConstant";
import { validDepot } from "./validation";
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalMaps from "../../../component/modal/ModalMaps";
import Geocode from "react-geocode";
import dayjs from "dayjs";
import moment from "moment";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";
import { onChanged } from "../../../util/Util";
import PICForm from "./Component/PICForm";
import EditOperationalDate from "../company-profile/edit/tab3-operational-date";
import CustomToogle from "../../../component/toogle/CustomToogle";
import { dropdownCustom, LoadingOption, selectOption } from "../../../component/select/SelectOption";

const DepotConfigEdit = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [subdistrict, setSubdistrict] = useState([]);
  const [urbanvillage, setUrbanvillage] = useState([]);
  const [postalcode, setPostalcode] = useState([]);
  const [title, setTitle] = useState([]);
  const [length, setLength] = useState([]);
  const [weight, setWeight] = useState([]);
  const [volume, setVolume] = useState([]);
  const [temperature, setTemperature] = useState([]);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState();
  const [isOpenMaps, setIsOpenMaps] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [c, setC] = useState("");
  const [i, setI] = useState("");
  const [p, setP] = useState("");
  const [d, setD] = useState("");
  const [s, setS] = useState("");
  const [u, setU] = useState("");
  const [pc, setPc] = useState("");
  const [addressFormat, setAddressFormat] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [errPostal, setErrPostal] = useState("");
  const [canAdd, setCanAdd] = useState(true);
  const [picList, setPicList] = useState([]);
  const [deletedPicList, setDeletedPicList] = useState([]);
  const [operationalDate, setOperationalDate] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  const [opsDate, setOpsDate] = useState([])

  console.log("detail", detail);
  const geocode = (address) => {
    setLoad(true);
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["depot_longitude"]: lng.toString(),
            ["depot_latitude"]: lat.toString(),
          };
        });
        if (form?.depot_address_1) {
          getPostalCode(lat, lng);
        }
        setLoad(false);
      },
      (error) => {
        console.error("geo eroer", error);
      }
    );
  };
  const actionBlur = (i) => {
    // if (addressFormat < 0) {
    let lnglat =
      c + "," + p + "," + d + "," + s + "," + u + "," + form?.depot_address_1;
    geocode(lnglat);
    // }
  };

  const onBlurPostal = () => {
    getRegionByPostalCode(form?.depot_postal_code);
  };

  const getPostalCode = (latitude, longitude) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latitude, longitude);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("postal_code")) {
            let eror = validDepot("depot_postal_code", component.long_name, t);
            setError({ ...error, ...eror });
            setForm((prevsValue) => {
              return {
                ...prevsValue,
                ["depot_postal_code"]: component.long_name,
              };
            });
            getRegionByPostalCode(component.long_name);
            return; // Exit the loop if postal code is found
          }
        }
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["depot_postal_code"]: "",
          };
        });
        console.log("Postal code not found.");
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  };
  const getRegionByPostalCode = async (code) => {
    try {
      let region = await doGets(`/postal_code/${code}`, token);
      let reg = region?.data?.payload?.data;
      getListCountry(1,100,"");
      getListProvince(reg?.country_id,1,100,"");
      getListDistrict(reg?.country_id, reg?.province_id,1,100,"");
      getListSubdistrict(reg?.country_id, reg?.district_id,1,100,"");
      getListUrbanvillage(reg?.country_id, reg?.sub_district_id,1,100,"");
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["depot_country"]: reg?.country_id,
          ["depot_province"]: reg?.province_id,
          ["depot_district"]: reg?.district_id,
          ["depot_sub_district"]: reg?.sub_district_id,
          ["depot_urban_village"]: reg?.urban_village_id,
        };
      });
      setErrPostal("");
      let lnglat =
        reg?.country_name +
        "," +
        reg?.province_name +
        "," +
        reg?.district_name +
        "," +
        reg?.sub_district_name +
        "," +
        reg?.urban_village_name +
        "," +
        code;

      // geocode(lnglat, index);
    } catch (err) {
      if (err.response.data.payload.code === "E-4-CMD-DTO-004") {
        setErrPostal("Postal Code not found");
      }
    }
  };
  const handleChange = (value, name) => {
    setChange(true);
    onChanged(dispatch, true);
    const isChange=true
    if (name === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "max_range") {
      let eror = validDepot("max_range", value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    } else if (name === "birth_date_pic") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    } else if (name === "depot_country") {
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListIsland(value);
      getListProvince(value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("depot_country", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["depot_island"]: "",
          ["depot_province"]: "",
          ["depot_district"]: "",
          ["depot_sub_district"]: "",
          ["depot_urban_village"]: "",
          ["depot_address_1"]: "",
          // ["depot_postal_code"]: "",
        };
      });
      setC([country[country.findIndex((el) => el.value === value)].label]);
      let lnglat = [
        country[country.findIndex((el) => el.value === value)].label,
      ];
      geocode(lnglat);
    } else if (name === "depot_island") {
      // setProvince([]);
      // setDistrict([]);
      // setSubdistrict([]);
      // setUrbanvillage([]);
      // setPostalcode([]);
      // getListProvince(value);
      let eror = validDepot("depot_island", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          // ["depot_province"]: "",
          // ["depot_district"]: "",
          // ["depot_sub_district"]: "",
          // ["depot_urban_village"]: "",
          // ["depot_postal_code"]: "",
        };
      });
    } else if (name === "depot_province") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListDistrict(form.depot_country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("depot_province", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["depot_district"]: "",
          ["depot_sub_district"]: "",
          ["depot_urban_village"]: "",
          ["depot_address_1"]: "",
          // ["depot_postal_code"]: "",
        };
      });
      setP([province[province.findIndex((el) => el.value === value)].label]);
      let lnglat =
        c +
        "," +
        [province[province.findIndex((el) => el.value === value)].label];
      geocode(lnglat);
    } else if (name === "depot_district") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListSubdistrict(form.depot_country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("depot_district", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["depot_sub_district"]: "",
          ["depot_urban_village"]: "",
          ["depot_address_1"]: "",
          // ["depot_postal_code"]: "",
        };
      });
      setD([district[district.findIndex((el) => el.value === value)].label]);
      let lnglat =
        c +
        "," +
        p +
        "," +
        [district[district.findIndex((el) => el.value === value)].label];
      geocode(lnglat);
    } else if (name === "depot_sub_district") {
      setUrbanvillage([]);
      setPostalcode([]);
      getListUrbanvillage(form.depot_country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("depot_sub_district", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["depot_urban_village"]: "",
          ["depot_address_1"]: "",
          // ["depot_postal_code"]: "",
        };
      });
      setS([
        subdistrict[subdistrict.findIndex((el) => el.value === value)].label,
      ]);
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        [subdistrict[subdistrict.findIndex((el) => el.value === value)].label];
      geocode(lnglat);
    } else if (name === "depot_urban_village") {
      let eror = validDepot("depot_urban_village", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["depot_address_1"]: "",
          // ["depot_postal_code"]: "",
        };
      });
      setPostalcode([]);
      getListPostalCode(form.depot_country, value);

      setU([
        urbanvillage[urbanvillage.findIndex((el) => el.value === value)].label,
      ]);
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        s +
        "," +
        [
          urbanvillage[urbanvillage.findIndex((el) => el.value === value)]
            .label,
        ];
      geocode(lnglat);
    } else if (name === "depot_postal_code") {
      // getListSubdistrict(form.country, value);
      let eror = validDepot("depot_postal_code", value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["depot_postal_code"]: value.target.value,
        };
      });
      // if (addressFormat < 0) {
      //   let lnglat =
      //     c +
      //     "," +
      //     p +
      //     "," +
      //     d +
      //     "," +
      //     s +
      //     "," +
      //     u +
      //     "," +
      //     i +
      //     " " +
      //     form?.depot_address_1;
      //   geocode(lnglat);
      // }
    } else if (name === "depot_address_1") {
      let eror = validDepot(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
      // if(addressFormat >=1){
      // if (addressFormat < 0) {
      //   let lnglat =
      //     c + "," + p + "," + d + "," + s + "," + u + "," + value.target.value;
      //   geocode(lnglat);
      // }
    } else if (name === "title_pic") {
      let eror = validDepot("title_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (
      name === "length_uom" ||
      name === "weight_uom" ||
      name === "volume_uom" ||
      name === "temperature_uom"
    ) {
      let eror = validDepot(name, value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "country_pic") {
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListIsland(value);
      getListProvince(value);
      let eror = validDepot("country_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["island_pic"]: "",
          ["province_pic"]: "",
          ["district_pic"]: "",
          ["sub_district_pic"]: "",
          ["depot_urban_village"]: "",
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "island_pic") {
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListProvince(value);
      let eror = validDepot("island_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["province_pic"]: "",
          ["district_pic"]: "",
          ["sub_district_pic"]: "",
          ["urban_village_pic"]: "",
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "province_pic") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListDistrict(form.country_pic, value);
      let eror = validDepot("province_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["district_pic"]: "",
          ["sub_district_pic"]: "",
          ["urban_village_pic"]: "",
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "district_pic") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListSubdistrict(form.country_pic, value);
      let eror = validDepot("district_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["sub_district_pic"]: "",
          ["urban_village_pic"]: "",
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "sub_district_pic") {
      setUrbanvillage([]);
      setPostalcode([]);
      getListUrbanvillage(form.country_pic, value);
      let eror = validDepot("sub_district_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["urban_village_pic"]: "",
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "urban_village_pic") {
      setPostalcode([]);
      getListPostalCode(value);
      let eror = validDepot("urban_village_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["postal_code_pic"]: "",
        };
      });
    } else if (name === "postal_code_pic") {
      // getListSubdistrict(form.country, value);
      let eror = validDepot("postal_code_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["postal_code_pic_id"]: value,
          ["postal_code_pic"]: value,
        };
      });
    } else {
      let eror = validDepot(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };

  const doGet = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const onSubmit = async () => {
    //page1
    let errors1 = {};
    let sub1 = {
      depot_name: form.depot_name ? form.depot_name : "",
      depot_description: form.depot_description ? form.depot_description : "",
      depot_email: form.depot_email ? form.depot_email : "",
      depot_phone: form.depot_phone ? form.depot_phone : "",
      // country_code_fax: "+62",
      depot_fax: form.depot_fax ? form.depot_fax : "",
      depot_country: form.depot_country ? form.depot_country : "",
      depot_island: form.depot_island ? form.depot_island : "",
      depot_province: form.depot_province ? form.depot_province : "",
      depot_district: form.depot_district ? form.depot_district : "",
      depot_1_district: form.depot_sub_district ? form.depot_sub_district : "",
      depot_urban_village: form.depot_urban_village
        ? form.depot_urban_village
        : "",
      depot_address_1: form.depot_address_1 ? form.depot_address_1 : "",
      depot_address_2: form.depot_address_2 ? form.depot_address_2 : "",
      depot_address_3: form.depot_address_3 ? form.depot_address_3 : "",
      depot_neighbourhood: form.depot_neighbourhood
        ? form.depot_neighbourhood
        : "",
      depot_hamlet: form.depot_hamlet ? form.depot_hamlet : "",
      depot_postal_code: form.depot_postal_code ? form.depot_postal_code : "",
      depot_longitude: form.depot_longitude ? form.depot_longitude : "",
      depot_latitude: form.depot_latitude ? form.depot_latitude : "",
    };
    for (const key in sub1) {
      const option = validDepot(key, sub1[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors1 = { ...currentError, ...errors1 };
    }
    setError(errors1);
    if (validateSubmit(errors1)) {
      let errors2 = {};
      let sub2 = {
        length_uom: form.length_uom ? form.length_uom : "",
        weight_uom: form.weight_uom ? form.weight_uom : "",
        volume_uom: form.volume_uom ? form.volume_uom : "",
        temperature_uom: form.temperature_uom ? form.temperature_uom : "",
        max_range: form.max_range ? form.max_range : "",
      };
      for (const key in sub2) {
        const option = validDepot(key, sub2[key], t);
        // let option = validUserProfile(key, value[key], this.props.t);
        const currentError = option;
        errors2 = { ...currentError, ...errors2 };
      }
      setError(errors2);
      if (validateSubmit(errors2)) {
        //page 3
        let errors = {};
        let opsdt = [];
        for (let i = 0; i < updatedOperationalDate?.length; i++) {
          const element = updatedOperationalDate[i];
          let datas = {
            date_start: element?.date_start,
            date_end: element?.date_end,
            date_start_code: element?.date_start_code,
            date_end_code: element?.date_end_code,
            description: element?.description,
            id: element?.id,
is_deleted: element?.is_deleted,
updated_at: element?.updated_at,
            is_operational_active: element?.is_operational_active === true ? "Y" : "N",
          };
          opsdt.push(datas);
        }
        const combinedPicList = picList.concat(deletedPicList)

        let sub = combinedPicList.map(item => (
          item.id_pic ?
            {
              position_pic: item.position_pic ? item.position_pic : "",
              title_pic: item.title_pic && (item.title_pic_id !== undefined || item.title_pic_id !== null) ? item.title_pic_id : item.title_pic ? item.title_pic : 0,
              first_name_pic: item.first_name_pic ? item.first_name_pic : "",
              last_name_pic: item.last_name_pic ? item.last_name_pic : "",
              gender_pic: item.gender_pic ? item.gender_pic : "M",
              birth_place_pic: item.birth_place_pic ? item.birth_place_pic : "",
              birth_date_pic: item.birth_date_pic ? dayjs(item.birth_date_pic).format('YYYY-MM-DD') : "1999-11-20",
              phone_number_pic: item.phone_number_pic && item.phone_number_pic.includes('+62-') ? item.phone_number_pic : item.phone_number_pic && !item.phone_number_pic.includes('+62-') ? '+62-' + item.phone_number_pic : '',
              email_pic: item.email_pic ? item.email_pic : "",
              nik_pic: item.nik_pic ? item.nik_pic : "",
              npwp_pic: item.npwp_pic ? item.npwp_pic : "123456789123456",
              country_pic: item.country_pic_id ? item.country_pic_id : item.country_pic ? item.country_pic : "",
              province_pic: item.province_pic_id ? item.province_pic_id : item.province_pic ? item.province_pic : "",
              district_pic: item.district_pic_id ? item.district_pic_id : item.district_pic ? item.district_pic : "",
              sub_district_pic: item.sub_district_pic_id ? item.sub_district_pic_id : item.sub_district_pic ? item.sub_district_pic : "",
              urban_village_pic: item.urban_village_pic_id ? item.urban_village_pic_id : item.urban_village_pic ? item.urban_village_pic : "",
              address_pic: item.address_pic ? item.address_pic : "",
              neighborhood_pic: item.neighborhood_pic ? item.neighborhood_pic : "",
              hamlet_pic: item.hamlet_pic ? item.hamlet_pic : "",
              postal_code_pic: item.postal_code_pic_id ? item.postal_code_pic_id : item.postal_code_pic ? item.postal_code_pic : "",
              updated_at: item.updated_at,
              is_deleted: item.is_deleted,
              id_pic: item.id_pic
            } :
            {
              position_pic: item.position_pic ? item.position_pic : "",
              title_pic: item.title_pic ? item.title_pic : 0,
              first_name_pic: item.first_name_pic ? item.first_name_pic : "",
              last_name_pic: item.last_name_pic ? item.last_name_pic : "",
              gender_pic: item.gender_pic ? item.gender_pic : "M",
              birth_place_pic: item.birth_place_pic ? item.birth_place_pic : "",
              birth_date_pic: item.birth_date_pic ? dayjs(item.birth_date_pic).format('YYYY-MM-DD') : "1999-11-20",
              phone_number_pic: item.phone_number_pic && item.phone_number_pic.includes('+62-') ? item.phone_number_pic : item.phone_number_pic && !item.phone_number_pic.includes('+62-') ? '+62-' + item.phone_number_pic : '',
              email_pic: item.email_pic ? item.email_pic : "",
              nik_pic: item.nik_pic ? item.nik_pic : "",
              npwp_pic: item.npwp_pic ? item.npwp_pic : "123456789123456",
              country_pic: item.country_pic_id ? item.country_pic_id : item.country_pic ? item.country_pic : "",
              province_pic: item.province_pic_id ? item.province_pic_id : item.province_pic ? item.province_pic : "",
              district_pic: item.district_pic_id ? item.district_pic_id : item.district_pic ? item.district_pic : "",
              sub_district_pic: item.sub_district_pic_id ? item.sub_district_pic_id : item.sub_district_pic ? item.sub_district_pic : "",
              urban_village_pic: item.urban_village_pic_id ? item.urban_village_pic_id : item.urban_village_pic ? item.urban_village_pic : "",
              address_pic: item.address_pic ? item.address_pic : "",
              neighborhood_pic: item.neighborhood_pic ? item.neighborhood_pic : "",
              hamlet_pic: item.hamlet_pic ? item.hamlet_pic : "",
              postal_code_pic: item.postal_code_pic_id ? item.postal_code_pic_id : item.postal_code_pic ? item.postal_code_pic : "",
            }
        ));

        let data = {
          ...form,
          depot_phone: "+62-" + form?.depot_phone,
          depot_neighborhood: form?.depot_neighbourhood,
          person_in_charge: sub,
          depot_postal_code: Number(form?.depot_postal_code),
          operational_hours: operationalDate,
          operational_date: opsdt,
          max_range: form?.max_range ? Number(form?.max_range) : 0,
        };
        for (const key in sub) {
          const option = validDepot(key, sub[key], t);
          const currentError = option;
          errors = { ...currentError, ...errors };
        }

        setError(errors);
        if (validateSubmit(errors)) {
          try {
            let res = await doGet(
              `/depot-configuration/${location.state}?${param}`,
              token,
              data
            );
            setSuccessModalOpen(true);
          } catch (err) {
            if (
              err?.response?.data?.payload?.message ===
              "Data with this Depot Name is already used by other, cant process this action"
            ) {
              setFailedModalOpen(true);
            }
          }
        }
      } else {
        setPage(2);
      }
    } else {
      setPage(1);
    }
  };

  const toMapsFull = (e) => {
    navigate(ROUTES.DEPOT_CONFIG.MAPS, { state: form });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    checkHasEmpty();
  }, [picList]);

  const fetchData = async (data) => {
    // setLoad(true);
    getDetail();
    getListCountry(1,10,"");
    getListTitle();
    getListLength();
    getListTemperature();
    getListVolume();
    getListWeight();

    let res = await doGets(
      `/address-format-configuration?page=1&limit=10?${param}`,
      token
    );
    setAddressFormat(
      res?.data?.payload?.data?.ListAddressFormatConfiguration?.map(
        (el) => el?.mandatory
      )?.findIndex((cek) => cek === "No")
    );
    // setLoad(false);
  };

  const getDetail = async () => {
    // setLoad(true);
    let res = await doGets(
      `/depot-configuration/${location.state}?${param}`,
      token
    );
    setDetail(res?.data?.payload?.data);
    let frmDepot = res?.data?.payload?.data?.depot_profile;
    let frmPrsn = res?.data?.payload?.data?.system_preferences;
    let frmSys = res?.data?.payload?.data?.person_in_charge;

    if (frmSys !== null) {
      setPicList(frmSys);
    }

    let opstime = [];
    for (let i = 0; i < res?.data?.payload?.data?.operational_time?.length; i++) {
      const element = res?.data?.payload?.data?.operational_time[i];
      const [hourString, minuteString, _] =
        element.operational_start_time.split(":");
      const [hourString2, minuteString2, _2] =
        element.operational_end_time.split(":");
      const hour = hourString
      const minute = minuteString
      const hour2 = hourString2
      const minute2 = minuteString2
      console.log("hr", hour,minute)
      let datas = {
        id: element.id,
        created_by: element.created_by,
        updated_at: element.updated_at,
        operational_day: element.operational_day,
        operational_start_time: hour + ":" + minute,
        operational_end_time: hour2 + ":" + minute2,
        is_operational_active: element.is_operational_active,
      };
      opstime.push(datas);
    }
    setOperationalDate(opstime);

    let opsDates=[]
    for (let i = 0; i < res?.data?.payload?.data?.operational_date?.length; i++) {
      const element = res?.data?.payload?.data?.operational_date[i];
      let datas = {
        ...element,
        date_start_code :"M"+moment(element?.date_start).format("MM"),
      date_end_code :"M"+moment(element?.date_end).format("MM"),
      
      };
      opsDates.push(datas);
    }
    setOpsDate(opsDates)
    getListIsland(frmDepot.depot_country_id,1,10,"");
    getListProvince(frmDepot.depot_country_id,1,100,"");
    getListDistrict(frmDepot.depot_country_id, frmDepot.depot_province_id,1,10,"");
    getListSubdistrict(frmDepot.depot_country_id, frmDepot.depot_district_id,1,10,"");
    getListUrbanvillage(
      frmDepot.depot_country_id,
      frmDepot.depot_sub_district_id,1,10,""
    );
    getListPostalCode(frmDepot.depot_urban_village_id);
    setC(frmDepot.depot_country);
    setP(frmDepot.depot_province);
    setD(frmDepot.depot_district);
    setS(frmDepot.depot_sub_district);
    setU(frmDepot.depot_urban_village);
    let frm = {
      depot_id: frmDepot?.depot_id,
      updated_at: res?.data?.payload?.data?.updated_at,
      depot_name: frmDepot.depot_name ? frmDepot.depot_name : "",
      depot_description: frmDepot.depot_description
        ? frmDepot.depot_description
        : "",
      depot_email: frmDepot.depot_email ? frmDepot.depot_email : "",
      depot_phone: frmDepot.depot_phone
        ? frmDepot.depot_phone?.substring(4)?.replace(")", "")
        : "",
      country_code_fax: "+62",
      depot_fax: frmDepot.depot_fax
        ? frmDepot.depot_fax?.substring(4)?.replace(")", "")
        : "",
      depot_country: frmDepot.depot_country_id ? frmDepot.depot_country_id : "",
      depot_island: frmDepot.depot_island_id ? frmDepot.depot_island_id : 0,
      depot_province: frmDepot.depot_province_id
        ? frmDepot.depot_province_id
        : "",
      depot_district: frmDepot.depot_district_id
        ? frmDepot.depot_district_id
        : "",
      depot_sub_district: frmDepot.depot_sub_district_id
        ? frmDepot.depot_sub_district_id
        : "",
      depot_urban_village: frmDepot.depot_urban_village_id
        ? frmDepot.depot_urban_village_id
        : 1,
      depot_address_1: frmDepot.depot_address_1 ? frmDepot.depot_address_1 : "",
      depot_address_2: frmDepot.depot_address_2 ? frmDepot.depot_address_2 : "",
      depot_address_3: frmDepot.depot_address_3 ? frmDepot.depot_address_3 : "",
      depot_neighbourhood: frmDepot.depot_neighborhood
        ? frmDepot.depot_neighborhood
        : "",
      depot_hamlet: frmDepot.depot_hamlet ? frmDepot.depot_hamlet : "",
      depot_postal_code: frmDepot.depot_postal_code_id
        ? frmDepot.depot_postal_code_id
        : "",
      depot_longitude: frmDepot.depot_longitude ? frmDepot.depot_longitude : "",
      depot_latitude: frmDepot.depot_latitude ? frmDepot.depot_latitude : "",
      person_in_charge: frmSys,
      max_range: frmPrsn.max_range
        ? Number(frmPrsn.max_range.split(" ")[0])
        : 0,
      length_uom: frmPrsn.length_uom_id ? frmPrsn.length_uom_id : "",
      weight_uom: frmPrsn.weight_uom_id ? frmPrsn.weight_uom_id : "",
      volume_uom: frmPrsn.volume_uom_id ? frmPrsn.volume_uom_id : "",
      temperature_uom: frmPrsn.temperature_uom_id
        ? frmPrsn.temperature_uom_id
        : "",
    };

    setForm(frm);
    // setLoad(false);
  };

  const getListCountry = async (page, limit, filter) => {


    const currentCountry = [...country];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${filter && `&filter=name lk ${filter}`
      }&${param}`,
      token
    );

    let option = [];
    let list = countrys?.data?.payload?.data;

    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      setCountry(selectOption(currentCountry, option, "value"));
      setLoading(false);
      // this.setState({
      //   listUser: selectOption(currentUser, option, "value"),
      //   initiateUser: initiate,
      //   loading: false,
      // });
    } else {
      setLoading(false);
      // this.setState({ loading: false, lastPage: true });
    }
  };

  const getListProvince = async (id, page, limit, filter,isChange) => {
    const currentProvince = [...province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setProvince(selectOption(isZero, option, "value"));
        }else{
        setProvince(selectOption(currentProvince, option, "value"));
        }
      // setProvince(selectOption(currentProvince, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  
  const isZero=[]
const getListDistrict = async (id, idprov,page, limit, filter,isChange ) => {

    const currentDistrict = [...district];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
      setDistrict(selectOption(isZero, option, "value"));
      }else{
      setDistrict(selectOption(currentDistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubdistrict = async (id, idprov, page, limit, filter,isChange) => {
    const currentSubdistrict = [...subdistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setSubdistrict(selectOption(isZero, option, "value"));
        }else{
        setSubdistrict(selectOption(currentSubdistrict, option, "value"));
        }
      // setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanvillage = async (id, idprov, page, limit, filter,isChange) => {
    const currentUrbanvillage = [...urbanvillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setUrbanvillage(selectOption(isZero, option, "value"));
        }else{
        setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
        }
      // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListTitle = async () => {
    let country = await doGets(`/person_title?page=1&limit=50&${param}`, token);
    let list = [];
    country?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.title,
      });
    });
    setTitle(list);
  };

  const getListIsland = async (id) => {
    let island = await doGets(
      `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
      token
    );
    let list = [];
    island?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.name,
      });
    });
    setIsland(list);
  };

 
  const getListPostalCode = async (idprov) => {
    let district = await doGets(
      `/postal_code?page=1&limit=50&order=id&filter=urban_village_id eq ${idprov}&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.code,
      });
    });
    setPostalcode(list);
  };

  const getListLength = async (id, idprov) => {
    let district = await doGets(
      `/uom/dropdown?page=1&limit=10&filter=category eq L&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.value,
      });
    });
    setLength(list);
  };
  const getListWeight = async (id, idprov) => {
    let district = await doGets(
      `/uom/dropdown?page=1&limit=10&filter=category eq W&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.value,
      });
    });
    setWeight(list);
  };

  const getListVolume = async (id, idprov) => {
    let district = await doGets(
      `/uom/dropdown?page=1&limit=10&filter=category eq V&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.value,
      });
    });
    setVolume(list);
  };

  const getListTemperature = async (id, idprov) => {
    let district = await doGets(
      `/uom/dropdown?page=1&limit=10&filter=category eq T&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.value,
      });
    });
    setTemperature(list);
  };

  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);

      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry);
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };

  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };
  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.depot_country, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(form?.depot_country, pageProvince, limitProvince, filter, true);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(form?.depot_country, pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(
        form?.depot_country,
        form?.depot_province,
        pageDistrict,
        limitDistrict,
        ""
      );
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(
          form?.depot_country,
          form?.depot_province,
          pageDistrict,
          limitDistrict,
          filter, true
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(
        form?.depot_country,
        form?.depot_province,
        pageDistrict,
        limitDistrict,
        filter
      );
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubdistrict(
        form?.depot_country,
        form?.depot_district,
        pageSubdistrict,
        limitSubdistrict,
        ""
      );
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubdistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubdistrict(
          form?.depot_country,
          form?.depot_district,
          pageSubdistrict,
          limitSubdistrict,
          filter, true
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubdistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubdistrict(
        form?.depot_country,
        form?.depot_district,
        pageSubdistrict,
        limitSubdistrict,
        filter
      );
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanvillage(
        form?.depot_country,
        form?.depot_sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanvillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanvillage(
          form?.depot_country,
          form?.depot_sub_district,
          pageUrbanvillage,
          limitUrbanvillage,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanvillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanvillage(
        form?.depot_country,
        form?.depot_sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        filter
      );
    }
  };


  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    let errors = {};
    let sub = {
      depot_name: form.depot_name ? form.depot_name : "",
      depot_description: form.depot_description ? form.depot_description : "",
      depot_email: form.depot_email ? form.depot_email : "",
      depot_phone: form.depot_phone ? form.depot_phone : "",
      // country_code_fax: "+62",
      depot_fax: form.depot_fax ? form.depot_fax : "",
      depot_country: form.depot_country ? form.depot_country : "",
      depot_island: form.depot_island ? form.depot_island : "",
      depot_province: form.depot_province ? form.depot_province : "",
      depot_district: form.depot_district ? form.depot_district : "",
      depot_sub_district: form.depot_sub_district
        ? form.depot_sub_district
        : "",
      depot_urban_village: form.depot_urban_village
        ? form.depot_urban_village
        : "",
      depot_address_1: form.depot_address_1 ? form.depot_address_1 : "",
      depot_address_2: form.depot_address_2 ? form.depot_address_2 : "",
      depot_address_3: form.depot_address_3 ? form.depot_address_3 : "",
      depot_neighbourhood: form.depot_neighbourhood
        ? form.depot_neighbourhood
        : "",
      depot_hamlet: form.depot_hamlet ? form.depot_hamlet : "",
      depot_postal_code: form.depot_postal_code ? form.depot_postal_code : "",
      depot_longitude: form.depot_longitude ? form.depot_longitude : "",
      depot_latitude: form.depot_latitude ? form.depot_latitude : "",
    };
    for (const key in sub) {
      const option = validDepot(key, sub[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setPage(2);
    }
  };

  const handleNextLast = () => {
    let errors = {};
    let sub = {
      length_uom: form.length_uom ? form.length_uom : "",
      weight_uom: form.weight_uom ? form.weight_uom : "",
      volume_uom: form.volume_uom ? form.volume_uom : "",
      temperature_uom: form.temperature_uom ? form.temperature_uom : "",
      max_range: form.max_range ? form.max_range : "",
    };
    for (const key in sub) {
      const option = validDepot(key, sub[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setPage(3);
    }
  };

  const addRow = () => {
    setPicList((prevsValue) => {
      return [...prevsValue, { id: "new" + Math.floor(Math.random() * 100) }];
    });
  };

  const checkHasEmpty = () => {
    if (_.isEmpty(picList)) {
      setPicList([{ id: `id${Math.floor(Math.random() * 100)}` }]);
      setCanAdd(false);
    } else {
      if (Object.keys(picList[picList.length - 1]).length === 1) {
        setCanAdd(false);
      } else {
        setCanAdd(true);
      }
    }
  };

  const page1 = () => {
    return (
      <>
        <div className="flex">
          <div>
            <div className="flex">
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("DEPOT:DEPOT_INFORMATION")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_NAME")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px] ml-2"
                    onChange={(value) => handleChange(value, "depot_name")}
                    status={error?.depot_name ? "error" : ""}
                    value={form.depot_name}
                    placeholder="Type depot name"
                  />

                  <div className="text-red-100">{error?.depot_name}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_DESC") + " (Optional)"}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px] ml-2"
                    onChange={(value) =>
                      handleChange(value, "depot_description")
                    }
                    status={error?.depot_description ? "error" : ""}
                    value={form.depot_description}
                    placeholder="Type depot description"
                  />

                  <div className="text-red-100">{error?.depot_description}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_EMAIL")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px] ml-2"
                    onChange={(value) => handleChange(value, "depot_email")}
                    status={error?.depot_email ? "error" : ""}
                    value={form.depot_email}
                    placeholder="Type depot email"
                  />

                  <div className="text-red-100">{error?.depot_email}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_PHONE")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="+62"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => handleChange(value, "depot_phone")}
                      status={error?.depot_phone ? "error" : ""}
                      value={form.depot_phone}
                      placeholder="Type depot phone"
                    />
                  </Space.Compact>

                  <div className="text-red-100">{error?.depot_phone}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_FAX") + " (Optional)"}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="+62"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => handleChange(value, "depot_fax")}
                      status={error?.depot_fax ? "error" : ""}
                      value={form.depot_fax}
                      placeholder="Type depot fax"
                    />
                  </Space.Compact>

                  <div className="text-red-100">{error?.depot_fax}</div>
                </div>
              </div>

              {/* line two */}
              <div className="gap-[40px] mb-[24px] ml-36">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("DEPOT:DEPOT_ADDRESS")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_COUNTRY")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.depot_country ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled
                    value={form.depot_country}
                    onChange={(value) => handleChange(value, "depot_country")}
                    // options={country}
                    placeholder="Select depot country"
                    onPopupScroll={(e) => onScrollCountry(e)}
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeCountry(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? country : [...country, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.depot_country}</div>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_ISLAND")+" (Optional)"}
                  </label>
                  <Select
                    className="w-[500px]"
                    disabled={!form.depot_country}
                    status={error?.depot_island ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.depot_island}
                    onChange={(value) => handleChange(value, "depot_island")}
                    options={island}
                    placeholder="Select depot island"
                  />
                  <div className="text-red-100">{error?.depot_island}</div>
                </div> */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_PROVINCE")}
                  </label>
                  <Select
                    className="w-[500px]"
                    disabled
                    value={form.depot_province}
                    status={error?.depot_province ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    onChange={(value) => handleChange(value, "depot_province")}
                    onPopupScroll={(e) => onScrollProvince(e)}
                    loading={loading}
                    // options={Province}
                    placeholder="Select Province"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeProvince(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? province : [...province, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.depot_province}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_DISTRICT")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.depot_district ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    disabled
                    value={form.depot_district}
                    size="large"
                    onChange={(value) => handleChange(value, "depot_district")}
                    onPopupScroll={(e) => onScrollDistrict(e)}
                    loading={loading}
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeDistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? district : [...district, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.depot_district}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_SUB_DISTRICT")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.depot_sub_district ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled
                    value={form.depot_sub_district}
                    onChange={(value) =>
                      handleChange(value, "depot_sub_district")
                    }
                    onPopupScroll={(e) => onScrollSubdistrict(e)}
                    loading={loading}
                    // options={Subdistrict}
                    placeholder="Select Subdistrict"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeSubdistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">
                    {error?.depot_sub_district}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_URBAN_VILLAGE")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.depot_urban_village ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled
                    value={form.depot_urban_village}
                    onChange={(value) =>
                      handleChange(value, "depot_urban_village")
                    }
                    onPopupScroll={(e) => onScrollUrbanvillage(e)}
                    loading={loading}
                    // options={Urbanvillage}
                    placeholder="Select depot Urbanvillage"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeUrbanvillage(value),
                        searchValue
                      )
                    }
                  >
                    {!loading
                      ? urbanvillage
                      : [...urbanvillage, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">
                    {error?.depot_urban_village}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_ADDRESS")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "depot_address_1")}
                    status={error?.depot_address_1 ? "error" : ""}
                    value={form.depot_address_1}
                    onBlur={() => actionBlur()}
                    disabled
                    placeholder="Type depot address"
                  />

                  <div className="text-red-100">{error?.depot_address_1}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_ADDRESS_2") + " (Optional)"}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "depot_address_2")}
                    status={error?.depot_address_2 ? "error" : ""}
                    value={form.depot_address_2}
                    disabled
                    placeholder="Type depot address 2"
                  />

                  <div className="text-red-100">{error?.depot_address_2}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:DEPOT_ADDRESS_3") + " (Optional)"}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "depot_address_3")}
                    status={error?.depot_address_3 ? "error" : ""}
                    value={form.depot_address_3}
                    disabled
                    placeholder="Type address 3"
                  />

                  <div className="text-red-100">{error?.depot_address_3}</div>
                </div>
                <div className="w-[500px] mb-[24px] flex">
                  <div>
                    <label className="font-roboto text-[16px] font-medium">
                      {t("CUSTOMER:HAMLET") + " (Optional)"}
                    </label>
                    <Input
                      className="mt-[8px] h-[47px] w-[200px]"
                      onChange={(value) => handleChange(value, "depot_hamlet")}
                      status={error?.depot_hamlet ? "error" : ""}
                      value={form.depot_hamlet}
                      disabled
                      placeholder="Type depot hamlet"
                    />

                    <div className="text-red-100">{error?.depot_hamlet}</div>
                  </div>
                  <div>
                    <label className="font-roboto text-[16px] font-medium">
                      {t("CUSTOMER:NEIGHBOURHOOD") + " (Optional)"}
                    </label>
                    <Input
                      className="mt-[8px] h-[47px] w-[200px]"
                      onChange={(value) =>
                        handleChange(value, "depot_neighbourhood")
                      }
                      disabled
                      status={error?.depot_neighbourhood ? "error" : ""}
                      value={form.depot_neighbourhood}
                      placeholder="Type depot neighborhood"
                    />

                    <div className="text-red-100">
                      {error?.depot_neighbourhood}
                    </div>
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("CUSTOMER:POSTAL_CODE")}
                  </label>
                  <Input
                    status={
                      error?.depot_postal_code || errPostal ? "error" : ""
                    }
                    onBlur={() => onBlurPostal()}
                    placeholder="Type Postal Code"
                    disabled
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={form.depot_postal_code}
                    onChange={(value) =>
                      handleChange(value, "depot_postal_code")
                    }
                  />
                  <div className="text-red-100">
                    {error?.depot_postal_code || errPostal}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Depot Longitude")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "depot_longitude")}
                    status={error?.depot_longitude ? "error" : ""}
                    value={form.depot_longitude}
                    disabled
                    placeholder="Type longitude"
                  />

                  <div className="text-red-100">{error?.depot_longitude}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Depot Latitude")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "depot_latitude")}
                    status={error?.depot_latitude ? "error" : ""}
                    value={form.depot_latitude}
                    placeholder="Type latitude"
                    disabled
                  />

                  <div className="text-red-100">{error?.depot_latitude}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[15px] font-bold">
                    {t("Depot Pinpoin")}
                  </label>
                  <div className="w-[500px] mb-[80px] h-20">
                    {!load ? (
                      <>
                        <MapsSmall
                          long={form.depot_longitude}
                          lat={form.depot_latitude}
                          onClicks={() => setIsOpenMaps(true)}
                        />
                      </>
                    ) : (
                      <>
                        <Spin size="large" margin={10} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const page2 = () => {
    return (
      <>
        <div className="flex">
          <div>
            <div className="flex">
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("DEPOT:SYSTEM_PREFERENCE_INFORMATION")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:LENGTH_UOM")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.length_uom ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.length_uom}
                    onChange={(value) => handleChange(value, "length_uom")}
                    options={length}
                    placeholder="Select length"
                  />
                  <div className="text-red-100">{error?.length_uom}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:WEIGHT_UOM")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.weight_uom ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.weight_uom}
                    onChange={(value) => handleChange(value, "weight_uom")}
                    options={weight}
                    placeholder="Select weight"
                  />
                  <div className="text-red-100">{error?.weight_uom}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:VOLUME_UOM")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.volume_uom ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.volume_uom}
                    onChange={(value) => handleChange(value, "volume_uom")}
                    options={volume}
                    placeholder="Select volume"
                  />
                  <div className="text-red-100">{error?.volume_uom}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:TEMPERATURE_UOM")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.temperature_uom ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.temperature_uom}
                    onChange={(value) => handleChange(value, "temperature_uom")}
                    options={temperature}
                    placeholder="Select temperature"
                  />
                  <div className="text-red-100">{error?.temperature_uom}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DEPOT:MAX_RANGE")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px] ml-2"
                    value={form?.max_range}
                    placeholder="Type max range"
                    onChange={(value) => handleChange(value, "max_range")}
                    status={error?.max_range ? "error" : ""}
                  />
                  <div className="text-red-100">{error?.max_range}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const page3 = () => {
    return (
      <>
        <div className="my-[40px] w-[1199px]">
          <p className="text-black-100 text-[18px] font-[600] mb-[16px]">
            Person in Charge Information
          </p>

          {picList ? (
            picList?.map((item, index) => {
              return (
                <div key={index}>
                  <PICForm
                    from={"edit"}
                    t={t}
                    style={style}
                    picList={picList}
                    setPicList={setPicList}
                    deletedPicList={deletedPicList}
                    setDeletedPicList={setDeletedPicList}
                    index={index}
                    id={item.id_pic ? item.id_pic : item.id}
                    checkHasEmpty={checkHasEmpty}
                    data={item}
                  />
                </div>
              );
            })
          ) : (
            <></>
          )}

          <div className="mb-[20px] w-full">
            {canAdd ? (
              <div
                className="h-[40px] bg-[#CF0000] cursor-pointer rounded-[10px] justify-center flex"
                onClick={() => addRow()}
              >
                <img src={AddIcon} alt="add" />
                <div
                  className={"text-[#FFFFFF] font-semibold text-2xl ml-2 mt-1"}
                >
                  Add New Person in Charge
                </div>
              </div>
            ) : (
              <div className="h-[40px] bg-[#D7D7D7] cursor-not-allowed rounded-[10px] justify-center flex">
                <img src={AddGrey} alt="add" />
                <div
                  className={"text-[#ACACAC] font-semibold text-2xl ml-2 mt-1"}
                >
                  Add New Person in Charge
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleToogle = (d, i) => {
    const newDetail = [...operationalDate];
    newDetail[i]["is_operational_active"] = d === "Y" ? "N" : "Y";
    if (d === "Y") {
      newDetail[i]["operational_start_time"] = "00:00";
      newDetail[i]["operational_end_time"] = "00:00";
    }
    setOperationalDate(newDetail);
  };

  const [errTime, setErrTime] = useState(["", "", "", "", "", "", ""]);
  const handleChangeTime = (value, key, index, i) => {
    const newDetail = [...operationalDate];
    const newErr = [...errTime];
    // if(index===0){
      const newFormat = index === 0 ? Number(value.target.value) > 23 ? 23 : Number(value.target.value) : Number(value.target.value) > 59 ? 59 : Number(value.target.value)
      // if(index===0){
      newDetail[i][key] = index === 0 ? newFormat + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + newFormat
  
    // }else{
    // newDetail[i][key]= newDetail[i][key].split(":")[0]+":"+value.target.value
    // }
    setOperationalDate(newDetail);
  };

  const handleBlur = (value, key, index, i)=>{
    const newDetail = [...operationalDate];
    const newErr = [...errTime];
    newDetail[i][key] = index === 0 ?(value.length===1 ? "0"+value : value) + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + (value.length===1 ? "0"+value : value) 
setOperationalDate(newDetail);
  }

  const page4 = () => {
    return (
      <>
        <div>
          <div className="w-[500px] mb-[24px] mt-6">
            <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
              {t("Operational Hours Information")}
            </h3>
          </div>
          {operationalDate?.map((d, i) => (
            <>
              <div className="flex w-[680px] font-medium font-roboto text-base">
                <div className="w-[160px] h-[25px]">{d.operational_day}</div>
                {d?.is_operational_active === "Y" ? (
                  <>
                    <div className="w-[160px]">From</div>
                    <div className="w-[40%]">To</div>
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div className="flex w-[680px]">
                <div className="w-[160px] h-[70px]">
                  <CustomToogle
                    namespace={"tglsetallaccess"}
                    checked={d?.is_operational_active === "Y" ? true : false}
                    handleChange={() =>
                      handleToogle(d?.is_operational_active, i)
                    }
                  />
                  {d?.is_operational_active === "Y" ? "Open" : "Close"}
                </div>
                {d?.is_operational_active === "Y" ? (
                  <>
                    <div className="w-[160px]">
                      <div className="flex w-[500px]">
                        <Input
                          className="mt-[8px] h-[47px] w-[55px] mr-2"
                          onChange={(value) =>
                            handleChangeTime(
                              value,
                              "operational_start_time",
                              0,
                              i
                            )
                          }
                          onBlur={() =>
                            handleBlur(
                              operationalDate[i]?.["operational_start_time"].split(":")[0],
                              "operational_start_time",
                              0,
                              i
                            )
                          }
                          // status={error?.shift_start_hour ? "error" : ""}
                          value={d?.operational_start_time.split(":")[0]}
                        />

                        <div className="text-red-100">
                          {/* {error?.shift_start_hour} */}
                        </div>
                        <img src={DotHour} alt="hour" />
                        <Input
                          className="mt-[8px] h-[47px] w-[55px] ml-2"
                          onChange={(value) =>
                            handleChangeTime(
                              value,
                              "operational_start_time",
                              1,
                              i
                            )
                          }onBlur={() =>
                            handleBlur(
                              operationalDate[i]?.["operational_start_time"].split(":")[1],
                              "operational_start_time",
                              1,
                              i
                            )
                          }
                          // status={error?.shift_start_min ? "error" : ""}
                          value={d?.operational_start_time.split(":")[1]}
                        />
                        {/* <div className="ml-5">
                      <img src={HourAM} alt="am" />
                    </div> */}
                        {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                      </div>
                    </div>
                    <div className="w-[40%]">
                      <div className="flex w-[500px]">
                        <Input
                          className="mt-[8px] h-[47px] w-[55px] mr-2"
                          onChange={(value) =>
                            handleChangeTime(
                              value,
                              "operational_end_time",
                              0,
                              i
                            )
                          }onBlur={(value) =>
                            handleBlur(
                              operationalDate[i]?.["operational_end_time"].split(":")[0],
                              "operational_end_time",
                              0,
                              i
                            )
                          }
                          // status={error?.shift_start_hour ? "error" : ""}
                          value={d?.operational_end_time.split(":")[0]}
                        />

                        <div className="text-red-100">
                          {/* {error?.shift_start_hour} */}
                        </div>
                        <img src={DotHour} alt="hour" />
                        <Input
                          className="mt-[8px] h-[47px] w-[55px] ml-2"
                          onChange={(value) =>
                            handleChangeTime(
                              value,
                              "operational_end_time",
                              1,
                              i
                            )
                          }onBlur={(value) =>
                            handleBlur(
                              operationalDate[i]?.["operational_end_time"].split(":")[1],
                              "operational_end_time",
                              1,
                              i
                            )
                          }
                          // status={error?.shift_start_min ? "error" : ""}
                          value={d?.operational_end_time.split(":")[1]}
                        />
                        {/* <div className="ml-5">
                      <img src={HourPM} alt="pm" />
                    </div> */}
                        {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          ))}
        </div>
      </>
    );
  };
  const getUpdatedOperationalDate = (data) => {
    setUpdatedOperationalDate(data);
    setOpsDate(data)
  };
  const [updatedOperationalDate, setUpdatedOperationalDate] = useState([]);
  console.log("updated", updatedOperationalDate);
  const page5 = () => {
    return (
      <>
        <EditOperationalDate
          data={updatedOperationalDate}
          oprDate={opsDate ? opsDate : []}
          updated={(data) => getUpdatedOperationalDate(data)}
        />{" "}
      </>
    );
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.DEPOT_CONFIG.LIST,
    });
  };

  const items = [
    {
      key: 1,
      label: <div onClick={() => setPage(1)}>Depot Profile</div>,
      children: page1(),
    },
    {
      key: 2,
      label: <div onClick={() => setPage(2)}>System Preference</div>,
      children: page2(),
    },
    {
      key: 3,
      label: <div onClick={() => setPage(3)}>Person in Charge</div>,
      children: page3(),
    },
    {
      key: 4,
      label: <div onClick={() => setPage(4)}>Operational Hours</div>,
      children: page4(),
    },
    {
      key: 5,
      label: <div onClick={() => setPage(5)}>Operational Date</div>,
      children: page5(),
    },
  ];
  return (
    <>
      <ModalMaps
        show={isOpenMaps}
        address={form.depot_address_1}
        latitude={form.depot_latitude}
        longitude={form.depot_longitude}
        onClose={() => setIsOpenMaps(false)}
      />
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.DEPOT_CONFIG.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been updated"
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be updated"
        description="Data with this Depot Name is already used by other, cant process this action"
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Depot Configuration`}
          menuLevel3={`Edit ${detail?.depot_profile?.depot_id} - ${detail?.depot_profile?.depot_name}`}
        />

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.DEPOT_CONFIG.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />

            <h1 className="font-sans-bold text-[28px]" id="title">
              Edit {detail?.depot_profile?.depot_id} -{" "}
              {detail?.depot_profile?.depot_name}
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            {/* <img
              src={page === 1 ? TabDepot1 : page === 2 ? TabDepot2 : TabDepot3}
              alt="tab"
            /> */}
            {!loading ? (
              <Tabs
                activeKey={page}
                items={items}
                className="border-b border-[#ffffff]"
              />
            ) : (
              <>...load</>
            )}
            {/* {!loading ? (
              page === 1 ? (
                page1()
              ) : page === 2 ? (
                page2()
              ) : (
                page3()
              )
            ) : (
              <>...load</>
            )} */}
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          {/* {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext()}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.DEPOT_CONFIG.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          ) : page === 2 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNextLast()}
              />
              <SecondaryButton text={t("Previous")} action={() => setPage(1)} />
            </>
          ) : ( */}
          <>
            <PrimaryButton
              text={t("USER_DETAIL:SAVE")}
              action={() => onSubmit()}
            />
            <SecondaryButton
              text={t("Cancel")}
              action={
                change
                  ? () => setShowConfirm(true)
                  : () => navigate(ROUTES.DEPOT_CONFIG.LIST)
              }
            />{" "}
          </>
          {/* )} */}
          {/* <PrimaryButton text={t("COMMON:NEXT")} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} /> */}
        </div>
      </div>
    </>
  );
};
export default DepotConfigEdit;
